import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { LoginModel } from 'src/app/model/login.model';
import { RegistroTransacoesService } from '../registro-transacoes.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SnackBarService } from 'src/app/services/snack-bar-service.service';
import { ConsultaTransacaoDetalhe, ConsultaTransacao, InfoTransacaoModel, InfoTransacaoModelResponse, Transacoes, Comprovante } from 'src/app/subFrota/model/abastecimentos-view-model';
import { DatePipe } from '@angular/common';
import { DomSanitizer, SafeResourceUrl, SafeHtml  } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-detalhe-registro-transacao',
  templateUrl: './detalhe-registro-transacao.component.html',
  styleUrls: ['./detalhe-registro-transacao.component.scss'],
  providers: [DatePipe]
})
export class DetalheRegistroTransacaoComponent implements OnInit {

  usuario !: LoginModel | undefined;
  loading = 0;
  dados!: Transacoes | any;
  acaoRapida:boolean = false;
  byPass:boolean = false;
  url_redirect: SafeResourceUrl | undefined;
  ocultarDadosDetalhes:boolean = false;
  content: SafeHtml = '';
  textoBtnDetalhe: string = '';
  consultaTransacao: ConsultaTransacao | any;
  consultaTransacaoDetalhe: ConsultaTransacaoDetalhe | any;
  comprovante: Comprovante | any;

  imagemTransacao: InfoTransacaoModelResponse = {
    retorno: undefined,
    sucesso: false,
    mensagens: []
  };
  
  temImagemOdometro: boolean = false;

  //todos os erros e caminhos de destinos
  erroMapeamento = [
    
    { erro: 0, 
      dscerro: "E_BLOQ_COMB_FRT_POSTO", 
      url: "",        
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S", 
    },
    { erro: 0, 
      dscerro: "EPRECO UNIT ZERADO", 
      url: "",        
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S", 
    },
    { erro: 0, 
      dscerro: "EXPOSTO/MUNIC BLOQ   ", 
      url: "",        
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S", 
    },
    { erro: 0, 
      dscerro: "EXSEM SALDO DE COTA", 
      url: "",        
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S", 
    },
    { 
      erro: 8, 
      dscerro: "Saldo insuficiente. ",
      url: environment.sistemas.portal_url + "/login/index?cmdName=92285", 
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S",
      parametros: [
        { nome: "id", valor: "coD_VEICULO" },
        { nome: "idCartao", valor: "coD_PRODUTO" }
      ]    
    },
    { 
      erro: 9, 
      dscerro: "Cartao Vencido.", 
      url: environment.sistemas.portal_url + "/login/index?cmdName=92413", 
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S",
      parametros: [
        { nome: "placa", valor: "dsC_PLACA" },
      ]  
    },
    { erro: 12, 
      dscerro: "Valor acima máximo. ", 
      url: "",        
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S", 
    },
    { erro: 16, 
      dscerro: "Timeout. ", 
      url: "",        
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S", 
    },
    { 
      erro: 19,
      dscerro: "Cartao Bloqueado. ",  
      url: environment.sistemas.portal_url + "/login/index?cmdName=92413", 
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S",
      parametros: [
        { nome: "placa", valor: "dsC_PLACA" },
      ]  
    },
    { 
      erro: 25,
      dscerro: "Duplicidade. ", 
      url: environment.sistemas.reportportalctfux + "/login.aspx?cmdName=1409", 
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S",
      parametros: [
        { nome: "id", valor: "coD_VEICULO" },
        { nome: "idCartao", valor: "coD_PRODUTO" }
      ],
      textoBtnDetalhe: "Ver detalhes" 
    },
    { erro: 32, 
      dscerro: "Banco do posto nao cadastrado na CTF. ", 
      url: "",        
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S", 
    },
    { 
      erro: 105,
      dscerro: "CPF NAO CADASTRADO NO SISTEMA. ",
      url: environment.sistemas.portal_url + "/login/index?cmdName=92283", 
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S",
      parametros: []  
    },
    { 
      erro: 111, 
      dscerro: "VEICULO BLOQUEADO. ",
      url: environment.sistemas.portal_url + "/login/index?cmdName=92285", 
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S",
      parametros: [
        { nome: "id", valor: "coD_VEICULO" },
        { nome: "idCartao", valor: "coD_PRODUTO" }
      ]  
    },
    { 
      erro: 112, 
      dscerro: "VEICULO BLOQUEADO PARA ESTE COMB. ", 
      url: environment.sistemas.cardsveiculo_url + "/login/Index?cmdName=2290", 
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S",
      parametros: [
        { nome: "placa", valor: "dsC_PLACA" },
      ]  
    },
    { 
      erro: 114, 
      dscerro: "HORARIO RESTRITO. ", 
      url: `${environment.sistemas.online_url}/login.aspx?cmdName=1692`,
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S",
      parametros: [
        { nome: "CODFROTA", valor: "coD_FROTA" },
        { nome: "CODSUBFROTA", valor: "paX_SUBFRT" }
      ]
     },
    {
      erro: 115,
      dscerro: "RESTRICAO DE KM.", 
      url: environment.sistemas.portal_url + "/login/index?cmdName=92285", 
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S",
      parametros: [
        { nome: "id", valor: "coD_VEICULO" },
        { nome: "idCartao", valor: "coD_PRODUTO" }
      ]
    },
    {
      erro: 116,
      dscerro: "RESTRICAO DE KM.", 
      url: environment.sistemas.portal_url + "/login/index?cmdName=92285", 
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S",
      parametros: [
        { nome: "id", valor: "coD_VEICULO" },
        { nome: "idCartao", valor: "coD_PRODUTO" }
      ]
    },
    { 
      erro: 118, 
      dscerro: "VEICULO BLOQUEADO NESTE POSTO. ",
      url: environment.sistemas.online_url + "/login.aspx?cmdName=2063",  //analisar qual bloqueio que foi 
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S",
      parametros: [
        { nome: "CodFrota", valor: "coD_FROTA" },
        { nome: "CodSubFrota", valor: "paX_SUBFRT" },        
        { nome: "CodVeiculo", valor: "coD_VEICULO" },
      ]
     },
     { erro: 120, 
      dscerro: "VALOR INVALIDO. ", 
      url: "",        
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S", 
    }, 
    { erro: 121, 
      dscerro: "VALOR TOTAL INVALIDO. ", 
      url: "",        
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S", 
    }, 
    { 
      erro: 122, 
      dscerro: "COMBUSTIVEL INVALIDO. ", 
      url: environment.sistemas.portal_url + "/login/index?cmdName=92285", 
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S",
      parametros: [
        { nome: "id", valor: "coD_VEICULO" },
        { nome: "idCartao", valor: "coD_PRODUTO" }
      ]  
    },
    { 
      erro: 123, 
      dscerro: "COMBUSTIVEL INVALIDO. ",  
      url: environment.sistemas.portal_url + "/login/index?cmdName=92285", 
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S",
      parametros: [
        { nome: "id", valor: "coD_VEICULO" },
        { nome: "idCartao", valor: "coD_PRODUTO" }
      ]  
    },
    { erro: 124, 
      dscerro: "NAO AUTORIZADO CONSULTE A CTF. ", 
      url: "",        
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S", 
    },
    { 
      erro: 126, 
      dscerro: "VEICULO BLOQUEADO NESTE POSTO.", 
      url: environment.sistemas.online_url + "/login.aspx?cmdName=2063",  //analisar qual bloqueio que foi 
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S",
      parametros: [
        { nome: "CodFrota", valor: "coD_FROTA" },
        { nome: "CodSubFrota", valor: "paX_SUBFRT" },        
        { nome: "CodVeiculo", valor: "coD_VEICULO" },
      ]
    },
    { 
      erro: 127, 
      dscerro: "VOLUME SUPERIOR A CAPACIDADE DE TANQUE. ", 
      url: environment.sistemas.portal_url + "/login/index?cmdName=92285", 
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S",
      parametros: [
        { nome: "id", valor: "coD_VEICULO" },
        { nome: "idCartao", valor: "coD_PRODUTO" }
      ]
    },
    { erro: 129, 
      dscerro: "REDE NAO HABILITADA NESTE POSTO. ", 
      url: "",        
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S", 
    },
    { erro: 133, 
      dscerro: "ID MOTORISTA BLOQUEADO. ", 
      url: "",        
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S", 
    },
    { 
      erro: 135, 
      dscerro: "ERRO SENHA TENTATIVA 1. ", 
      url: environment.sistemas.portal_url + "/login/index?cmdName=92283", 
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S",
      parametros: [
        { nome: "NUM_CPF", valor: "nuM_CPF" }
      ]
    },
    { 
      erro: 136,
      dscerro: "ERRO SENHA TENTATIVA 2. ",
      url: environment.sistemas.portal_url + "/login/index?cmdName=92283", 
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S",
      parametros: [
        { nome: "NUM_CPF", valor: "nuM_CPF" }
      ]
    },
    { 
      erro: 137,
      dscerro: "SENHA BLOQUEADA. ",
      url: environment.sistemas.portal_url + "/login/index?cmdName=92283", 
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S",
      parametros: [
        { nome: "NUM_CPF", valor: "nuM_CPF" }
      ]
    },
    { erro: 143, 
      dscerro: "POSTO INTERNO NAO PERCENTE A FROTA. ", 
      url: "",        
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S", 
    },
    { erro: 155, 
      dscerro: "OPERACAO BLOQUEADA CONSULTE CTF.", 
      url: "",        
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S", 
    },
    { 
      erro: 156,
      dscerro: "BLOQUEIO_PRECO_BOMBA_PORTAL. ",
      url: environment.sistemas.portal_url + "/login/index?cmdName=92393", 
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S",
      parametros: [
        { nome: "id", valor: "coD_VEICULO" },
        { nome: "idCartao", valor: "coD_PRODUTO" }
      ]
    },
    { 
      erro: 160, 
      dscerro: "VOLUME SUPERIOR A CAPACIDADE DE TANQUE NO PERIODO. ",
      url: environment.sistemas.portal_url + "/login/index?cmdName=92285", 
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S",
      parametros: [
        { nome: "id", valor: "coD_VEICULO" },
        { nome: "idCartao", valor: "coD_PRODUTO" }
      ]
    },
    {
      erro: 170,
      dscerro: "RESTRICAO DE KM.", 
      url: environment.sistemas.portal_url + "/login/index?cmdName=92285", 
      urlByPass: `${environment.sistemas.portal_url}ByPass/Novo`,  
      bypass: "S",
      parametros: [
        { nome: "id", valor: "coD_VEICULO" },
        { nome: "idCartao", valor: "coD_PRODUTO" }
      ]
    },
  ];

  constructor(
    private authenticationService: AuthenticationService,
    private registroTransacoesService: RegistroTransacoesService,
    private snackBar: SnackBarService,
    private renderer: Renderer2,
    private router: Router,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<DetalheRegistroTransacaoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer,
    private http: HttpClient) {
    this.dados = data;
    //this.formattedDate = this.datePipe.transform(this.yourDateVariable, 'dd/MM/yyyy HH:mm:ss')!;    
  }

  

  ngOnInit(): void {

    //console.log(this.dados);
    // Liga a animação de Loading (Spinner) na tela 
    this.loading++;

    this.usuario = this.registroTransacoesService?.usuario;

    // Verifica se o guid do usuário é ou continua válido.
    this.authenticationService.validate(this.registroTransacoesService?.usuario?.retorno?.guid ?? '')
      .then((dados => {

        if (!dados.sucesso) {
          this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
          this.usuario = undefined;
        } else {
          this.obterImagemTransacao();
          this.detalheItem();
        }
      }))
      .catch(() => {
        this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
      })
      .finally(() => {
        this.loading--;
      });
  }

  private buildUrlWithParams(link: string, params: any[] | undefined, row: any): string {
    const url = new URL(link, window.location.origin);

    if (params != undefined) {
      params.forEach(param => {
        const value = row[param.valor]; // Obtém o valor do row baseado no campo 'valor'
        if (value !== undefined) {
          url.searchParams.append(param.nome, value);
        }
      });
      if (this.usuario != undefined)
        url.searchParams.append("userGuid", this.usuario?.retorno.guid);
    }
    return url.toString();
  }

  

  fechar() {
    this.dialogRef.close();
  }

  detalheItem() {
    var dadosRedirectErro = this.erroMapeamento.find(d => d.erro === parseInt(this.dados.coD_ERRO, 10))


    if (dadosRedirectErro != undefined && dadosRedirectErro.textoBtnDetalhe != undefined && dadosRedirectErro.textoBtnDetalhe != ''){
      this.textoBtnDetalhe = dadosRedirectErro.textoBtnDetalhe;
    }
    
    if (dadosRedirectErro != undefined && dadosRedirectErro.url != undefined && dadosRedirectErro.url != ''){
      this.acaoRapida = true;
    }

    if (dadosRedirectErro != undefined && dadosRedirectErro.bypass != undefined && dadosRedirectErro.bypass == 'S'){
      this.byPass = true;
    }

    
  }

chamarByPass() {
    var dadosRedirectErro = this.erroMapeamento.find(d => d.erro === parseInt(this.dados.coD_ERRO, 10));
    var linkBypass = dadosRedirectErro?.urlByPass
    if (dadosRedirectErro != undefined && linkBypass != undefined && linkBypass != ''){
      if (linkBypass) {
        var url = this.buildUrlWithParams(linkBypass, [], this.dados);
        this.url_redirect = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.ocultarDadosDetalhes = true;
      } 
    } else {
        alert("Sem ação rápida para essa mensagem:\n" + dadosRedirectErro?.dscerro);
    }
}

  chamarAjusteRegra() {
//console.log(dados);
    var dadosRedirectErro = this.erroMapeamento.find(d => d.erro === parseInt(this.dados.coD_ERRO, 10))
    //console.log(dadosRedirectErro);
    if (dadosRedirectErro != undefined && dadosRedirectErro.url != undefined && dadosRedirectErro.url != ''){
      if (dadosRedirectErro != undefined) {
        var url = this.buildUrlWithParams(dadosRedirectErro.url, dadosRedirectErro.parametros, this.dados);
        this.url_redirect = this.sanitizer.bypassSecurityTrustResourceUrl(url);

        this.ocultarDadosDetalhes = true;
      }
    }else{
      alert("Sem ação rápida para essa mensagem:\n" + dadosRedirectErro?.dscerro);
    }
  }

  
  private async obterImagemTransacao(){
    try{
      var data: InfoTransacaoModel = {guid: this.usuario?.retorno?.guid,codAbastecimento:this.dados.coD_ABASTECIMENTO};
      this.loading++;
      this.registroTransacoesService.obterImagemTransacao(data)
      .subscribe({
        next: (res: InfoTransacaoModelResponse) => {
          this.imagemTransacao = res;
          if (this.imagemTransacao?.sucesso) {
            this.temImagemOdometro = this.imagemTransacao?.retorno?.imG_BASE64 != undefined 
            && this.imagemTransacao?.retorno?.imG_BASE64 != null
            && this.imagemTransacao?.retorno?.imG_BASE64.length > 0;
          }
          this.loading--;
          if(this.loading < 0){
            this.loading = 0;
          }
        },
        complete: () => {}
      });
    }catch(err){
      console.error(err);
      this.loading--;
      if(this.loading < 0){
        this.loading = 0;
      }
    }
  }

  mostrarImagemTransacao: boolean = false;
  verImagemTransacao(){
    if(this.temImagemOdometro){
      //alert("Exibe imagem do hodometro");
      this.mostrarImagemTransacao = true;
    }else{
      //alert("Nenhuma imagem associada");
    }
  }

  fecharImagemTransacao(){
    this.mostrarImagemTransacao = false;
  }

  loadContent(url:string): void {
    
    this.http.get(url, { responseType: 'text' }).subscribe({
      next: (data) => {
        this.content = this.sanitizer.bypassSecurityTrustHtml(data); // Sanitiza o conteúdo HTML
      },
      error: (err) => {
        console.error('Erro ao carregar a URL:', err);
      }
    });
  }

  getKmAnterior(status: string): string {
    if (!status) return '';
    const termo = "Anterior ";
    const posicao = status.indexOf(termo);
    if (posicao === -1) return '';
    const trecho = status.slice(posicao + termo.length).trim();
    const match = trecho.match(/\d+/);
    return match ? match[0] : '';
  }

  getKmAtual(status: string): string {
  if (!status) return '';

  const termoInicio = "atual ";
  const termoFim = " vs";
  
  const posInicio = status.toLowerCase().indexOf(termoInicio);
  const posFim = status.toLowerCase().indexOf(termoFim);

  if (posInicio !== -1 && posFim !== -1) {
    // Recorta o que está entre 'atual ' e ' vs'
    return status.substring(posInicio + termoInicio.length, posFim).trim();
  }

  return '';
  }

  formatarComprovante(texto: string): string {
  if (!texto) return '';
  // Substitui cada '#1' ou '@' por uma quebra de linha HTML
  return texto.replace(/#1|@/g, '<br />');
  }
}
